import {Button, Grid, Typography} from '@yandex-delivery/blocks'
import {useFormContext} from '@yandex-delivery/form'
import React, {memo} from 'react'

import type {Props} from '../types'
import {useDisableReason, useSubmitButtonDetails, useSubmitButtonTitle, useSubmitHandler} from './hooks'
import * as classes from './SubmitButtonOffers.classes'

export const SubmitButtonOffers = memo<Props>(function SubmitButtonOffers({formRef, isLoading = false}) {
  const {isSubmitting, isValidating, isValid, watch} = useFormContext()
  const {ETA, price} = useSubmitButtonDetails()
  const title = useSubmitButtonTitle()
  const disableReason = useDisableReason()
  const submitHandler = useSubmitHandler(formRef)

  const isOffersPending = watch('offerFlow.isPending', false)

  const isDisabled = !isValid || !!disableReason
  const buttonVariant = isDisabled ? 'default' : 'action'
  const textColor = isDisabled ? 'minor' : 'main'
  const loading = isSubmitting || isValidating || isOffersPending || isLoading

  return (
    <Button
      data-e2e="submit-button"
      loading={loading}
      onPress={loading ? undefined : submitHandler}
      size="l"
      variant={buttonVariant}
      fullWidth
    >
      <Grid alignItems="center" className={classes.container} size="s" container>
        <Typography color={textColor} Component={Grid} variant="body2" item xs>
          {disableReason ? null : ETA}
        </Typography>
        <Grid item>
          <Grid alignItems="center" direction="column" container>
            <Typography color={textColor} Component={Grid} thickness="medium" variant="body2">
              {title}
            </Typography>
            {isSubmitting ? null : disableReason ? (
              <Typography
                className={textColor === 'main' ? classes.subTitle : undefined}
                color={textColor}
                Component={Grid}
                variant="caption1"
              >
                {disableReason}
              </Typography>
            ) : null}
          </Grid>
        </Grid>
        <Typography color={textColor} Component={Grid} justify="flex-end" variant="body2" item xs>
          {disableReason ? null : price}
        </Typography>
      </Grid>
    </Button>
  )
})
